import { useAppContext } from "../../../../lib/appContext";

import {
  IOffersQueryProps,
  OffersData,
  OffersQuery,
  QueryName
} from "../../../../queries/products/components/OffersQuery";
import {
  ProductQueryProps,
  QueryResponse as ProductData,
  ProductQuery
} from "../../../../queries/products/components/ProductQuery";

export type QueryVariables = ProductQueryProps["variables"] &
  Partial<IOffersQueryProps["variables"]>;

export const getQuery = (isOffer: boolean): React.ComponentType<any> =>
  isOffer ? OffersQuery : ProductQuery;

type IsValidProduct = (data?: ProductData) => boolean;
export const isValidProduct: IsValidProduct = data =>
  Boolean(data) && Boolean(data!.productDetailsBySlug) && Boolean(data!.productDetailsBySlug!.code);

type ParseProductResponse = (
  data: ProductData,
  variables: QueryVariables
) => { product: ProductData["productDetailsBySlug"] } | undefined;
const parseProductResponse: ParseProductResponse = data =>
  isValidProduct(data) ? { product: data.productDetailsBySlug } : undefined;

const parseOfferResponse = (data: OffersData, countryCode: string) => {
  const offerQueryName = `ci${countryCode}Offers` as QueryName;
  const parsedDataArray = data[offerQueryName];
  const parsedData =
    Array.isArray(parsedDataArray) && parsedDataArray.length > 0
      ? { ...parsedDataArray[0] }
      : undefined;

  if (parsedData == null) {
    return undefined;
  }

  if (parsedData.product.productAttributes != null) {
    const productAttributes = parsedData.product.productAttributes
      .filter(attr => attr != null)
      .map(attribute => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const group = (attribute.entity as any).group;
        const groupType = typeof group;
        return {
          ...attribute,
          enabled:
            groupType === "object" && group != null && group.code === "config"
              ? false
              : attribute.enabled
        };
      });

    const sortedProductAttributes = productAttributes.sort((a, b) =>
      a != null && b != null ? (a.level || 0) - (b.level || 0) : 0
    );

    parsedData.product.productAttributes = sortedProductAttributes;
  }

  return parsedData;
};

export const useParseResponse = (isOffer: boolean, variables: QueryVariables) => {
  const { countryCode } = useAppContext();
  return (data: any) => {
    if (isOffer) {
      return parseOfferResponse(data, countryCode);
    }
    return parseProductResponse(data, variables);
  };
};
